var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mapLoader)?_c('div',{staticClass:"mapLoader"},[_c('v-progress-circular',{attrs:{"size":50,"width":4,"color":"#2E674F","indeterminate":""}})],1):_vm._e(),_c('div',{staticClass:"adoptionMapWidth"},[_c('div',{ref:"google-map",staticClass:"google-map",attrs:{"id":"google-map"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }